import React from 'react';
import Experience from '../components/Experience';
import './Page.css';

function ExperiencePage() {
  return (
    <div className="page-container">
      <Experience />
    </div>
  );
}

export default ExperiencePage;
